import InternalLink from "../util/navigation/InternalLink.jsx";
import {APP_ROUTES} from "../../App.jsx";

export default ({presetId, id, icon}) => {
    const isSelected = parseInt(presetId) === id
    return (
        <InternalLink to={APP_ROUTES.liveListPreset.replace(':presetId', id)}
                      className={`${isSelected ? 'is-selected' : ''}`}>
            {icon}
        </InternalLink>
    )
}